import { css } from '@emotion/react';
import { theme } from './theme';

import { AnimationSlideDown } from './animations';

export const NotificationStyle = () => css`
	background: ${theme.color.text['400']};
	color: #fff;
	font-size: 13px;
	line-height: 18px;
	border-radius: 12px;
	padding: 15px 20px 16px;
	margin-bottom: 4px;
	box-shadow: 0 24px 32px -2px rgba(0, 0, 0, 0.2);
	animation: ${AnimationSlideDown()} 0.3s ease;
`;
